export const enRegister = {
  //text
  notRegistered: 'If you have not registered yet, please register for the first time.',
  notRegistered2: 'If you are registering for YELLoop for the first time, please register for an account first.',
  haveAccount: 'If you already have a YELLoop account, please log in and register to join the community.',
  haveAccount2: 'If you already have an account, please log in and register to join the community. ',
}
